import makeStyles from '@mui/styles/makeStyles';
import { alpha } from '@mui/material/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    '@media print': {
      display: 'none',
    },

    '& h6': {
      width: '100%',
    },
  },
  contentRoot: {
    backgroundColor: theme.palette.primary.dark,
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    [theme.breakpoints.up('sm')]: {
      marginRight: 20,
    },
  },
  taskButton: {
    height: theme.spacing(2),
    minWidth: theme.spacing(16),
    flexShrink: 0,
    [theme.breakpoints.down('md')]: {
      minWidth: theme.spacing(8),
    },
  },
  menuButtonSidebar: {
    marginLeft: -12,
  },
  title: {
    textAlign: 'center',
    textTransform: 'capitalize',
    display: 'none',
    [theme.breakpoints.between('sm', 'md')]: {
      display: 'block',
    },
  },
  headerlogoWrapper: {
    marginLeft: 'auto',
    marginRight: 'auto',
    height: 120,
    display: 'flex',
    alignItems: 'center',
  },
  headerlogo: {
    margin: theme.spacing(1),
    maxHeight: '100px',
    maxWidth: '200px',
  },
  performlogo: {
    margin: '24px auto',
    maxWidth: '100px',
  },
  copyright: {
    display: 'block',
    fontSize: '11px',
    margin: 'auto',
    marginTop: theme.spacing(2),
  },
  menuTitle: {
    textTransform: 'capitalize',
  },
  hidden: {
    display: 'none',
  },
  active: {
    backgroundColor: theme.palette.action.hover,
    fontWeight: 'bold',
  },
  locationButton: {
    backgroundColor: theme.palette.primary.dark,
    '&:hover': {
      backgroundColor: theme.colors.darkGrey,
    },
  },
  locationFocus: {
    backgroundColor: theme.colors.darkGrey,
  },
  locationIcon: {
    marginLeft: theme.spacing(1),
  },
  tabIcon: {
    marginRight: theme.spacing(1),
  },
  tabs: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },

    '& .MuiTabs-indicator': {
      backgroundColor: theme.palette.secondary.main,
    }
  },
  tab: {
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
    color: alpha(theme.palette.primary.contrastText, 0.75),
    '&.Mui-selected': {
      color: theme.palette.primary.contrastText,
    },
  },
  resetButton: {
    minWidth: 'inherit',
    width: theme.spacing(5),
  },
  newlink: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default useStyles;
